import Clear from 'material-ui/svg-icons/content/clear';
import IconButton from 'material-ui/IconButton';
import muiTheme from '../../../styles/teamologyTheme';
import React, {PropTypes} from 'react';

export default function MobileFormHeader({title, onGoBackTouchTap}) {
  return (
    <div className="mobile-form-header">
      <div>{title}</div>
      <IconButton onTouchTap={onGoBackTouchTap} iconStyle={{color: muiTheme.palette.primary1Color}}><Clear /></IconButton>
    </div>
  );
}

MobileFormHeader.propTypes = {
  onGoBackTouchTap: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./app/features/shared/components/MobileFormHeader.js